import { InjectionToken } from '@angular/core';
import {
  type IInvoice,
  type IPatient,
  type IStaffer,
  type ITransaction,
} from '@principle-theorem/principle-core/interfaces';
import {
  type DocumentReference,
  type WithRef,
} from '@principle-theorem/shared';
import { type Observable } from 'rxjs';

export interface IClaimEstimateProviders {
  isEnabled$: Observable<boolean>;

  capture(
    invoice: IInvoice,
    practitioner: WithRef<IStaffer>,
    patient: WithRef<IPatient>
  ): Promise<DocumentReference<ITransaction> | undefined>;
}

export const CLAIM_ESTIMATE_PROVIDER =
  new InjectionToken<IClaimEstimateProviders>('CLAIM_ESTIMATE_PROVIDER');
